import React, { FC } from 'react';
import ReactDOM from 'react-dom';

export const PortalWrapper: FC<{ offset?: number; children: React.ReactNode; percent?: number }> = ({
  children,
  offset = 0,
  percent = 35,
}) => {
  return ReactDOM.createPortal(
    <div
      style={{
        position: 'absolute',
        bottom: `calc(${percent}% + ${offset}px)`,
        width: '100%',
        padding: '0 16px',
        pointerEvents: 'auto',
      }}
    >
      {children}
    </div>,
    document.getElementById('overlay-root')!,
  );
};
